import { Badge, lighten, Stack, useTheme } from '@mui/material'
import CellHOC from '@platform/react/hoc/list/cell'
import { getFirstItem, getThemeColor } from 'lib/util'
import { useMemoRef } from '@platform/react/hook'
import Icon from 'ui/Element/Icon'

/**
 * Custom styles for the component.
 */
const cellStyles = () => ({
  root: {
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    // justifyContent: 'center',
  },
})

const statusMapping = {
  10: 'primary.main',
  20: 'warning.main',
  30: 'success.main',
  80: 'text.secondary',
}

const _getStatusColors = (theme, status) => ({
  color: getThemeColor(theme, statusMapping[status] || 'black.main'),
  background: lighten(getThemeColor(theme, statusMapping[status] || 'background.selected'), 0.9),
})

/**
 * Intended to display the icon of the ticket.
 *
 * @param {Object} classes  styling for the cell
 * @param {Object} props    props for the cell
 *
 * @returns {JSX.Element}
 */
const ListItemCellTicketIcon = (classes, props = {}) => {
  const theme = useTheme()
  const { type: typeKey, workState, status, unreadMessages, events } = props
  const [type] = events?.getTicketType?.(typeKey) || []
  const typeIcon = type?.icon

  const { color = 'black.main', backgroundColor = 'background.selected' } = getFirstItem(
    events?.getStatus?.(status)
    // status === 80
    //   ? events?.getStatusReason?.(workState)
    //   : events?.getStatus?.(status),
  ) || {}

  return (
    <Stack
      spacing={2}
      direction={'row'}
      sx={{ alignSelf: 'center' }}
    >
      <Badge
        color={'signal'} // background-color
        overlap={'circular'}
        badgeContent={unreadMessages}
        sx={{ color: theme.palette.white.main }}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Icon
          size={24}
          color={color}
          rounded={true}
          source={typeIcon}
          background={backgroundColor}
        />
      </Badge>
    </Stack>
  )
}

export default useMemoRef(CellHOC(ListItemCellTicketIcon, cellStyles), props => [
  props.type,
  props.workState,
  props.status,
  props.unreadMessages,
])
